export const DECIMAL_PLACES = {
  /** Used for currency display (e.g. $1,234.56) */
  CURRENCY: 2,
  /** Used for most financial calculations */
  FINANCIAL: 4,
  /** Used for precise calculations (e.g. SDI, SBC) */
  PRECISE: 6,
};

export const DECIMAL_PLACEHOLDERS = {
  /** Placeholder for currency display */
  CURRENCY: '$0.00',
  /** Placeholder for financial calculations */
  FINANCIAL: '$0.0000',
  /** Placeholder for precise calculations */
  PRECISE: '$0.000000',
};
